import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

type PredictionType = ClientInferResponseBody<typeof contract.quoteRequestLines.predict>;

type Props = {
  quoteRequestLineId: string;
  shouldHandleAssembly: boolean;
  failedOrUnStartedChildrenOnly: boolean;
};

export const predictQuoteRequestLine = async ({
  quoteRequestLineId,
  shouldHandleAssembly,
  failedOrUnStartedChildrenOnly,
}: Props): Promise<PredictionType | null> => {
  const response = await api.quoteRequestLines.predict.mutation({
    params: {
      id: quoteRequestLineId,
    },
    body: {
      shouldHandleAssembly,
      failedOrUnStartedChildrenOnly,
    },
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError(
    "Erreur lors de la prédiction des étapes de gamme",
    response.status,
    response.body,
  );
};
